module.exports = __webpack_public_path__ + "static/media/corect.c59c1ab1.mp3";